import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmationDialogService } from '@libs/shared/ui/dialogs/confirmation-dialog/confirmation-dialog.service';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';

@NgModule({
  declarations: [ConfirmationDialogComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  providers: [ConfirmationDialogService],
  exports: [ConfirmationDialogComponent],
})
export class ConfirmationDialogModule {
  constructor(private _confirmationDialogService: ConfirmationDialogService) {}
}
